/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

/**
 * European Union (EU) member states as of 2024
 * Based on official EU documentation and ISO 3166-1 alpha-2 country codes
 *
 * Note: This list includes all 27 current EU member states
 * The United Kingdom (GB) is not included as it left the EU in 2020
 */
export const EU_COUNTRY_CODES = new Set([
	"AT", // Austria
	"BE", // Belgium
	"BG", // Bulgaria
	"HR", // Croatia
	"CY", // Cyprus
	"CZ", // Czech Republic
	"DK", // Denmark
	"EE", // Estonia
	"FI", // Finland
	"FR", // France
	"DE", // Germany
	"GR", // Greece
	"HU", // Hungary
	"IE", // Ireland
	"IT", // Italy
	"LV", // Latvia
	"LT", // Lithuania
	"LU", // Luxembourg
	"MT", // Malta
	"NL", // Netherlands
	"PL", // Poland
	"PT", // Portugal
	"RO", // Romania
	"SK", // Slovakia
	"SI", // Slovenia
	"ES", // Spain
	"SE", // Sweden
]);

/**
 * Helper function to check if a country code is an EU member state
 * @param countryCode - ISO 3166-1 alpha-2 country code
 * @returns true if the country is an EU member state, false otherwise
 */
export const isEUCountry = (countryCode: string): boolean => {
	return EU_COUNTRY_CODES.has(countryCode.toUpperCase());
};
